import { useState } from 'react';
import './Blog.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/Popup';
import Image from './6.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <div className='blogPageMainScreen'>
        <div className='blogPageMainScreenContent'>
          <span className='blogPageMainScreenBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path
                d='M7.9987 12.6667L3.33203 7.99999M3.33203 7.99999L7.9987 3.33333M3.33203 7.99999H12.6654'
                stroke='#3A6376'
                stroke-width='1.33'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Back to Articles
          </span>
          <h1 className='blogPageMainScreenTitle'>Healthcare CEO KPIs for 2019: Metrics that Matter</h1>
          <span className='blogPageMainScreenDate'>December 21, 2025</span>
          <div className='blogPageMainScreenImage'>
            <img src={Image} />
          </div>
        </div>
      </div>
      <div className='blogPageContent'>
        <p>
          As a hospital CEO, it is natural to focus attention on reacting to the ever-changing demands of the organization without
          taking time to pause for assessment. The most successful CEOs we have worked with share that having a short set of key
          performance indicators (KPIs) that are easy to review on a daily, quarterly, and annual basis helps keep the core
          objectives front and center amidst the constant requests of leadership.
        </p>
        <p>
          Many of the CEOs we have placed report that having an online dashboard (ideally mobile-friendly) to be able to take a
          look at the day’s key metrics is one of the most valuable tools in their leadership arsenal. Often, the IT team is
          already collecting many of the vital data points, so getting a dashboard in place may be a simple project request. For
          CEOs just starting on a simplified version of KPIs, Becker’s Healthcare Review recommends the following metrics:
        </p>
        <h3>METRICS & ISSUES TO MONITOR DAILY</h3>
        <ol>
          <li>
            <b>Outpatient no-shows.</b> If you notice these numbers are high, you might consider tweaking or changing your
            reminder system. No-shows hurt productivity and cost the healthcare industry billions every year.
          </li>
          <li>
            <b>First case start-times.</b> Consistent monitoring of start times is crucial for keeping the OR running smoothly.
          </li>
          <li>
            <b>Patient volume.</b> How many patients are admitted to the OR, ER, and hospital each day?
          </li>
          <li>
            <b>“Door-to-doc” time in the emergency department.</b> The length of patients’ wait time has implications on staffing
            levels, patient safety, and patient and employee satisfaction. These metrics are available to the public on Medicare
            Hospital Compare, and patients will use this information to decide which hospital to visit.
          </li>
          <li>
            <b>“Decision to admit to departure” time in ED.</b> After a physician decides to admit a patient to an inpatient bed,
            how much time passes before the patient leaves the ED for that bed?
          </li>
          <li>
            <b>The number of patients who leave the ED without being seen.</b> If this number is high, it indicates ED crowding
            and longer ED wait times. Patients who leave without being seen are more likely to report worsened health problems.
          </li>
          <li>
            <b>Major service issues.</b> If patients are upset, it may be better to handle those situations personally.
          </li>
          <li>
            <b>Major engagement issues.</b> If physicians or employees are upset, it’s imperative to address those issues quickly.
            Employee engagement not only affects patient safety but also process improvement. Employee and physician satisfaction
            be regular agenda items at department head and medical executive committee meetings.
          </li>
        </ol>
        <h3>METRICS & ISSUES TO MONITOR QUARTERLY</h3>
        <ol>
          <li>
            <b>Quality metrics.</b> How are the hospital’s HCAHPS results, the process of care measures, and outcome measures?
            HCAHPS scores directly influence the hospitals’ operating margins; quality and profit, in this case, go hand-in-hand.
          </li>
          <li>
            <b>Employee metrics.</b> Are employees satisfied have direct correlations to turnover rates. Employee engagement is a
            necessity in high-performing organizations. Studer suggests holding quarterly employee forums to give employees a
            chance to be heard.
          </li>
          <li>
            <b>Physician metrics.</b> Don’t forget referral patterns and satisfaction ratings. It’s essential that physicians are
            engaged in hospital operations and view the organization as a great place to practice medicine.
          </li>
          <li>
            <b>Philanthropy.</b> Many organizations visit this once a year, but Studer says quarterly is better when so many
            hospitals are struggling to sustain themselves. Government funding is getting harder to obtain, making philanthropy
            even more critical. When do donations increase and decrease? Why? Also, be sure to keep the lines of communication
            open and let donors know where their funds went.
          </li>
          <li>
            <b>Board communications.</b> While this is in the “quarterly” category, it should probably happen more frequently.
            Communication between board members should happen often, and not just in times of crisis. Meet with each board member
            individually and find out what he or she defines as healthy communication.
          </li>
        </ol>
        <h3>STEPS TO TAKE ANNUALLY</h3>
        <ol>
          <li>
            <b>Hold an intensive leadership assessment.</b> Are your leaders aligned in terms of mindset and resources? Is there a
            sense of urgency for constant improvement? Do your processes hold people accountable for executing well? There are
            several leadership assessments available to measure these vital leadership qualities.
          </li>
          <li>
            <b>Audit your evaluation system.</b> Are your leader assessments matching up to the results of your leaders’
            responsibilities? Using an objective evaluation tool that’s linked to hard goals versus subjective measurements
            fosters an environment of data-driven standards.
          </li>
          <li>
            <b>Evaluate contracts.</b> When looking at partner agreements, the focus should be on cost and performance. If your
            hospital is ranking low in cleanliness and you outsource those services, it’s time to reevaluate that contract. Where
            possible, tie performance into contracts with these types of vendors.
          </li>
        </ol>
        <p>
          While keeping close eyes on the health of your organization may not always be enjoyable, it’s necessary. Taking time
          every day to check your KPI dashboard may require adopting new habits, but the long-term gains in your organization’s
          health will be more than worth it.
        </p>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default BlogPage;
